/**
 * Full-screen mobile search takeover — open/close wiring only.
 * ------------------------------------------------------------------
 * Opens custom-searchtab-predictive-search-mobile.liquid's panel from
 * the header's search icon (rendered inline in sections/header.liquid) and
 * closes it again. Deliberately independent of CustomPredictiveSearch's
 * own open/close state — it only toggles the panel's visibility and focuses its input;
 * CustomPredictiveSearch's existing `focus` handler takes it from there
 * (opens the dropdown, loads the default/recommended state).
 * ------------------------------------------------------------------
 */
(function () {
  const toggleBtn = document.getElementById('custom-predictive-search-mobile-toggle');
  const panel = document.querySelector('[data-predictive-search-mobile-panel]');

  if (!toggleBtn || !panel) return;

  const closeBtn = panel.querySelector('[data-predictive-search-mobile-close]');
  const input = panel.querySelector('[data-predictive-search-input]');

  function openPanel() {
    panel.hidden = false;
    document.documentElement.classList.add('cps-mobile-scroll-locked');
    toggleBtn.setAttribute('aria-expanded', 'true');
    if (input) {
      requestAnimationFrame(() => input.focus());
    }
  }

  function closePanel() {
    panel.hidden = true;
    document.documentElement.classList.remove('cps-mobile-scroll-locked');
    toggleBtn.setAttribute('aria-expanded', 'false');
    toggleBtn.focus();
  }

  toggleBtn.addEventListener('click', openPanel);

  if (closeBtn) {
    closeBtn.addEventListener('click', closePanel);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) closePanel();
  });
})();
